// Utilidades de descarga de archivos en el navegador (Tarea 19E).

/** MIME de un .xlsx. */
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Descarga un contenido base64 como archivo (crea un blob temporal). */
export function downloadBase64(base64: string, filename: string, mime: string): void {
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: mime });
  const url = URL.createObjectURL(blob);
  triggerDownload(url, filename);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Descarga desde una URL (p. ej. prefirmada de S3). */
export function downloadUrl(url: string, filename: string): void {
  triggerDownload(url, filename);
}

function triggerDownload(url: string, filename: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
